export default "__VITE_ASSET__B1XP3wDy__"